<template>
    <kgr-form-scaffold
        :with-primary-buttons="false"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-team-employees-provider
            v-slot="teamEmployeeRelations"
            :team-id="teamId"
        >
            <div class="animated fadeIn">
                <kgr-team-employees-relations-form
                    :team-employee-relations="teamEmployeeRelations.data"
                    :team-id="teamId"
                    :club-id="clubId"
                    :error="error"
                    :is-creatable="isCreatable"
                    @updated="onUpdate(teamEmployeeRelations.reload)"
                />
            </div>
        </kgr-team-employees-provider>
    </kgr-form-scaffold>
</template>

<script>
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold';
import KgrTeamEmployeeRelationsForm from '../../components/team/TeamEmployeeRelationsForm';
import TeamEmployeesProvider from '../../components/data-provider/TeamEmployeesProvider';


export default {
    components: {
        'kgr-team-employees-relations-form': KgrTeamEmployeeRelationsForm,
        'kgr-team-employees-provider': TeamEmployeesProvider,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        teamId: {
            type: Number,
            required: true,
        },
        isCreatable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            error: new Error(),
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onUpdate(reload) {
            reload();
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
